export function AccordionSchemaEnhancer({ schema, formData, intl }) {
  schema.properties.title_size.default = 'h3';
  schema.fieldsets = [
    {
      ...schema.fieldsets[0],
      fields: [...schema.fieldsets[0].fields, 'non_exclusive', 'collapsed'],
    },
  ];
  return schema;
}
